<template>
  <div class="c-designer">
    <designer-filter @on-search="filterData" @on-down="downTlp" @on-import="importExcel" />
    <div class="c-m-table">
      <Viewport v-model="tableHeight">
        <designer-table
          ref="designerTable"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :summary="summary"
          :height="tableHeight"
          @on-details="details"
          @on-refresh="filterData"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          size="small"
          class="c-table-page"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>

    <resulter
      v-model="modal"
      type="回款计算器"
      :add-total="added"
      :update-total="updated"
      :fail-total="failure"
      :table-data="success_d"
      @on-close="resultOk"
    />
  </div>
</template>

<script>
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import mixinTable from './mixin_table'
import columns from '../data/designer_columns'

import DesignerFilter from './components/designer-filter.vue'
import DesignerTable from './components/designer-table.vue'
import Resulter from '@/components/export/result-dialog'

import { findDesignerInfoByPage, importDesignerInfo } from '@/api/manage.model'

export default {
  name: 'designer',
  mixins: [mixinTable],
  components: { DesignerFilter, DesignerTable, Resulter },
  data() {
    return {
      tableHeight: 330,
      modal: false,
      loading: false,
      tableData: [],
      sumData: [],
      columns: columns,
      success_d: [],
      added: 0,
      failure: 0,
      updated: 0
    }
  },
  methods: {
    resultOk() {
      this.modal = false
      this.pageIndex = 1
      this.getData()
    },
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      findDesignerInfoByPage(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info, sum_data } = data
        if (isArray(list) && page_info && sum_data) {
          const { total_number } = page_info
          this.sumData = sum_data
          this.total = total_number || 0
          this.tableData = list
        } else this.tableData = []
        this.$nextTick(() => {
          this.$refs.designerTable && this.$refs.designerTable.doLayout()
        })
      })
    },
    summary(param) {
      const { columns } = param
      const data = this.sumData
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        sums[index] = data[prop]
      })
      return sums
    },
    details(row) {
      const { month, designerId, designerName } = row
      this.$store.commit('setIndexRoute', 'designer')
      this.$store.commit('setBreadcrumb', [
        {
          title: '3D设计人员',
          href: {
            to: 'designer'
          }
        },
        {
          title: '明细'
        }
      ])
      this.$router.push({
        name: 'designerdetail',
        query: {
          month: `${month}-01`,
          designerId: designerId,
          designerName: designerName
        }
      })
    },
    downTlp() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_designer`)
    },
    importExcel(file) {
      this.$Spin.show()
      importDesignerInfo({ file }).then((data) => {
        this.$Spin.hide()
        if (!data) return
        if (isArray(data.list)) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.success_d = data.list.map((ret) => {
            return {
              row_line: Object.keys(ret)[0],
              msg: ret[Object.keys(ret)[0]]
            }
          })
          this.modal = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
